import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  count: number;
};

export const ImplausibleWarningStep: React.FC<Props> = ({ count }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-start gap-2">
        <span className="text-orange-500 text-lg" aria-hidden="true">⚠</span>
        <div>
          <p className="font-medium">{t('management.import.warning.title')}</p>
          <p className="text-sm text-gray-600 mt-1">
            {t('management.import.warning.body', { count })}
          </p>
        </div>
      </div>
    </div>
  );
};
